import GroupManagement from './GroupManagement';

export default GroupManagement;
